import types from '../types/header'
import communityActions from '../../community/actions/community'
import yoursActions from '../../yours/actions/yours'
import catalogActions from '../../catalog/actions/catalog'

let searchTimer = null

export default class header {

  static searchMore() {
    return function(dispatch, getState) {

      dispatch({
        type: types.SEARCH_MORE,
      })

      switch (getState().ui.header.header.get('tab')) {
        case 'community':
          dispatch(communityActions.searchMore())
          break
        case 'yours':
          dispatch(yoursActions.searchMore())
          break
        case 'catalog':
          dispatch(catalogActions.searchMore())
          break
        default:
      }
    }
  }

  static initialSearch() {
    return function(dispatch, getState) {

      dispatch({
        type: types.SET_SEARCH,
        payload: {
          search: '',
        },
      })

      switch (getState().ui.header.header.get('tab')) {
        case 'community':
          dispatch(communityActions.search())
          break
        case 'yours':
          dispatch(yoursActions.search())
          break
        case 'catalog':
          dispatch(catalogActions.search())
          break
        default:
      }
    }
  }

  static setSearch(search) {
    return function(dispatch, getState) {

      dispatch({
        type: types.SET_SEARCH,
        payload: {
          search,
        },
      })

      switch (getState().ui.header.header.get('tab')) {
        case 'community':
          clearTimeout(searchTimer)
          searchTimer = setTimeout(() => {
            dispatch(communityActions.search())
          }, 250)
          break
        case 'yours':
          clearTimeout(searchTimer)
          searchTimer = setTimeout(() => {
            dispatch(yoursActions.search())
          }, 250)
          break
        case 'catalog':
          clearTimeout(searchTimer)
          searchTimer = setTimeout(() => {
            dispatch(catalogActions.search())
          }, 250)
          break
        default:
      }

    }
  }

}



// WEBPACK FOOTER //
// ./src/sections/header/actions/header.js